import "./WithdrawalPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Widerrufsbelehrung from "./sections/Widerrufsbelehrung";
import Footer from "@/reusable_sections/Footer";
export default function WithdrawalPolicyPage() {
  return <div>
      <Header />
      <Widerrufsbelehrung />
      <Footer />
    </div>;
}